import { getCommunities } from '../../network/API'
import { getCustomersSelect } from '../../network/Customers'

const GiftCard = {
    title: 'gift_card_information',
    key: [],
    sections: [
        {
            columns: 6,
            fields: [
                {
                    label: 'GIFT_CARDS_GRANTED_BY',
                    isInactive: true,
                    key: ['grantedByName'],
                    pos: {
                        col: 1,
                        row: 1,
                        size: 1,
                    },
                },
                {
                    label: 'GIFT_CARDS_GIFT_CARD_ID',
                    isInactive: true,
                    key: ['giftCardID'],
                    pos: {
                        col: 2,
                        row: 1,
                        size: 1,
                    },
                },
                {
                    label: 'CUSTOMERS_CUSTOMER_NAME',
                    type: 'select',
                    requestOption: getCustomersSelect,
                    key: ['customer'],
                    pos: {
                        col: 1,
                        row: 2,
                        size: 1,
                    },
                },
                {
                    label: 'GIFT_CARDS_OFFERED_BY',
                    type: 'select',
                    requestOption: getCustomersSelect,
                    key: ['offeredBy'],
                    pos: {
                        col: 2,
                        row: 2,
                        size: 1,
                    },
                },
                {
                    label: 'amount',
                    suffixLabel: '¥',
                    type: 'number',
                    isRequired: true,
                    key: ['amount'],
                    pos: {
                        col: 1,
                        row: 3,
                        size: 1,
                    },
                },
                {
                    label: 'ZIKO_SPECIALS_EXPIRATION_DATE',
                    type: 'date',
                    key: ['expirationDate'],
                    pos: {
                        col: 2,
                        row: 3,
                        size: 1,
                    },
                },
                {
                    label: 'COMMUNITY_COMMUNITY',
                    key: ['communities'],
                    isRequired: true,
                    type: 'multicheck',
                    requestOption: getCommunities,
                    pos: {
                        col: 1,
                        row: 4,
                        size: 1,
                    },
                },
                {
                    key: ['type'],
                    type: 'hidden',
                },
                {
                    key: ['grantedBy'],
                    type: 'hidden',
                },
                {
                    key: ['status'],
                    type: 'hidden',
                },
            ],
        },
    ],
}

export { GiftCard }

const GiftCardEdit = {
    title: 'gift_card_information',
    key: [],
    sections: [
        {
            columns: 6,
            fields: [
                {
                    label: 'GIFT_CARDS_GRANTED_BY',
                    isInactive: true,
                    key: ['grantedByName'],
                    pos: {
                        col: 1,
                        row: 1,
                        size: 1,
                    },
                },
                {
                    label: 'GIFT_CARDS_GIFT_CARD_ID',
                    isInactive: true,
                    key: ['giftCardID'],
                    pos: {
                        col: 2,
                        row: 1,
                        size: 1,
                    },
                },
                {
                    label: 'GIFT_CARDS_TYPE',
                    type: 'select',
                    isInactive: true,
                    options: [
                        { key: 'purchase', label: 'purchase' },
                        { key: 'gift', label: 'gift' },
                        { key: 'manual', label: 'manual' },
                        { key: 'other', label: 'other' },
                    ],
                    key: ['type'],
                    pos: {
                        col: 1,
                        row: 2,
                        size: 1,
                    },
                },
                {
                    label: 'CUSTOMERS_CUSTOMER_NAME',
                    type: 'select',
                    requestOption: getCustomersSelect,
                    key: ['customer'],
                    isRequired: false,
                    allowClear: true,
                    pos: {
                        col: 1,
                        row: 3,
                        size: 1,
                    },
                },
                {
                    label: 'GIFT_CARDS_OFFERED_BY',
                    type: 'select',
                    requestOption: getCustomersSelect,
                    key: ['offeredBy'],
                    isRequired: false,
                    allowClear: true,
                    pos: {
                        col: 2,
                        row: 3,
                        size: 1,
                    },
                },
                {
                    label: 'amount',
                    suffixLabel: '¥',
                    type: 'number',
                    isRequired: true,
                    key: ['amount'],
                    pos: {
                        col: 1,
                        row: 4,
                        size: 1,
                    },
                },
                {
                    label: 'ZIKO_SPECIALS_EXPIRATION_DATE',
                    type: 'date',
                    key: ['expirationDate'],
                    pos: {
                        col: 2,
                        row: 4,
                        size: 1,
                    },
                },
                {
                    label: 'COMMUNITY_COMMUNITY',
                    key: ['communities'],
                    isRequired: true,
                    type: 'multicheck',
                    requestOption: getCommunities,
                    pos: {
                        col: 1,
                        row: 5,
                        size: 1,
                    },
                },
                {
                    key: ['grantedBy'],
                    type: 'hidden',
                },
                {
                    key: ['status'],
                    type: 'hidden',
                },
            ],
        },
    ],
}

export { GiftCardEdit }
